"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.crohnDiseaseIsActiveMessages = exports.crohnDiseaseMessages = exports.colitisUlcerosaIsActiveMessages = exports.colitisUlcerosaMessages = exports.CrohnDiseaseIsActive = exports.CrohnDisease = exports.ColitisUlcerosaIsActive = exports.ColitisUlcerosa = void 0;
const schema_1 = require("../../../../schema");
var ColitisUlcerosa;
(function (ColitisUlcerosa) {
    ColitisUlcerosa["ABNORMAL"] = "ABNORMAL";
    ColitisUlcerosa["NORMAL"] = "NORMAL";
})(ColitisUlcerosa || (exports.ColitisUlcerosa = ColitisUlcerosa = {}));
var ColitisUlcerosaIsActive;
(function (ColitisUlcerosaIsActive) {
    ColitisUlcerosaIsActive["ACTIVE"] = "ACTIVE";
    ColitisUlcerosaIsActive["INACTIVE"] = "INACTIVE";
})(ColitisUlcerosaIsActive || (exports.ColitisUlcerosaIsActive = ColitisUlcerosaIsActive = {}));
var CrohnDisease;
(function (CrohnDisease) {
    CrohnDisease["ABNORMAL"] = "ABNORMAL";
    CrohnDisease["NORMAL"] = "NORMAL";
})(CrohnDisease || (exports.CrohnDisease = CrohnDisease = {}));
var CrohnDiseaseIsActive;
(function (CrohnDiseaseIsActive) {
    CrohnDiseaseIsActive["ACTIVE"] = "ACTIVE";
    CrohnDiseaseIsActive["INACTIVE"] = "INACTIVE";
})(CrohnDiseaseIsActive || (exports.CrohnDiseaseIsActive = CrohnDiseaseIsActive = {}));
exports.colitisUlcerosaMessages = {
    [ColitisUlcerosa.ABNORMAL]: {
        id: "ltx.phaseI.consultations.colonoscopia.colitisUlcerosa.ABNORMAL",
        defaultMessage: "Igen"
    },
    [ColitisUlcerosa.NORMAL]: {
        id: "ltx.phaseI.consultations.colonoscopia.colitisUlcerosa.NORMAL",
        defaultMessage: "Nem"
    }
};
exports.colitisUlcerosaIsActiveMessages = {
    [ColitisUlcerosaIsActive.ACTIVE]: {
        id: "ltx.phaseI.consultations.colonoscopia.colitisUlcerosaIsActive.ACTIVE",
        defaultMessage: "Aktív"
    },
    [ColitisUlcerosaIsActive.INACTIVE]: {
        id: "ltx.phaseI.consultations.colonoscopia.colitisUlcerosaIsActive.INACTIVE",
        defaultMessage: "Nem aktív"
    }
};
exports.crohnDiseaseMessages = {
    [CrohnDisease.ABNORMAL]: {
        id: "ltx.phaseI.consultations.colonoscopia.crohnDisease.ABNORMAL",
        defaultMessage: "Igen"
    },
    [CrohnDisease.NORMAL]: {
        id: "ltx.phaseI.consultations.colonoscopia.crohnDisease.NORMAL",
        defaultMessage: "Nem"
    }
};
exports.crohnDiseaseIsActiveMessages = {
    [CrohnDiseaseIsActive.ACTIVE]: {
        id: "ltx.phaseI.consultations.colonoscopia.crohnDiseaseIsActive.ACTIVE",
        defaultMessage: "Aktív"
    },
    [CrohnDiseaseIsActive.INACTIVE]: {
        id: "ltx.phaseI.consultations.colonoscopia.crohnDiseaseIsActive.INACTIVE",
        defaultMessage: "Nem aktív"
    }
};
const colitisUlcerosa = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(ColitisUlcerosa.ABNORMAL),
    schema_1.Schema.singleChoiceItem(ColitisUlcerosa.NORMAL)
])
    .expiration(15552000)
    .interpretation({ vocab: "ltx", code: "colitis_ulcerosa" });
const colitisUlcerosaIsActive = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../colitisUlcerosa} === "ABNORMAL"`), schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(ColitisUlcerosaIsActive.ACTIVE),
    schema_1.Schema.singleChoiceItem(ColitisUlcerosaIsActive.INACTIVE)
]).interpretation({ vocab: "ltx", code: "colitis_ulcerosa_activity" }));
const crohnDisease = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(CrohnDisease.ABNORMAL),
    schema_1.Schema.singleChoiceItem(CrohnDisease.NORMAL)
])
    .expiration(15552000)
    .interpretation({ vocab: "ltx", code: "crohn_disease" });
const crohnDiseaseIsActive = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../crohnDisease} === "ABNORMAL"`), schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(CrohnDiseaseIsActive.ACTIVE),
    schema_1.Schema.singleChoiceItem(CrohnDiseaseIsActive.INACTIVE)
]).interpretation({ vocab: "ltx", code: "crohn_disease_activity" }));
const comment = schema_1.Schema.string()
    .optional()
    .maxLength(10000)
    .interpretation({ vocab: "ltx", code: "colonoscopia_comment" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({
    colitisUlcerosa,
    colitisUlcerosaIsActive,
    crohnDisease,
    crohnDiseaseIsActive,
    comment
})
    .interpretation({ vocab: "ltx", code: "colonoscopia" })
    .tag({ vocab: "snomed", code: "20135006" })
    .tag({ vocab: "snomed", code: "169069000" });
